import './App.css';
import { AllRoutes } from './components/Routes';
import { useState } from "react";

function App() {

  
  
  return (
    <div className="App">
        <AllRoutes />

    </div>
  );
}

export default App;